import script from "./PlatformLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformLayout.vue?vue&type=script&setup=true&lang=js"

import "./PlatformLayout.vue?vue&type=style&index=0&id=320cd412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-320cd412"]])

export default __exports__